import { atom } from 'jotai';

export interface ReportTracker {
  /**
   * Optional sonner toast id. Present when a "Generating PDF report…" loading
   * toast was shown at start time (standalone "Generate PDF report" button) —
   * useReportProgress then UPDATES that same toast into a success/error toast.
   * Absent when triggered from the deviation modal (the deviation toast
   * already conveys progress), in which case useReportProgress creates a
   * NEW toast on completion.
   */
  toastId?: string | number;
  batchId: string;
  projectId: string;
  title: string;
}

export const reportTrackingAtom = atom<ReportTracker[]>([]);
